<ion-app>
  <litello-app-header *ngIf="!isAuthPage" [isMenuOpened]="isMenuOpened"></litello-app-header>
  <app-menu (menuToggle)="menuToggleHandler($event)" [isAuthPage]="isAuthPage"></app-menu>
</ion-app>
